import * as React from "react";
import { Row, Col } from "antd";
import AuthContext from "Context/AuthContext";
import { TableCol, RightColLayout, LeftColLayout, HeaderCol } from "./ConfirmationDetail.Styled";
import { IBillOfLadingReceiptDto, IBillOfLadingPaymentResponse, IVerifyFirstAtlanticPaymentResponse } from "Core/Api/Payment/Api";
import Utility from "Core/Utility";
import moment from "moment";

export interface Props {
    children?: React.ReactNode,
    paymentResponse?: IVerifyFirstAtlanticPaymentResponse,
    // referenceNumber?: string;
}

export interface State {
}

export default class ConfirmationDetail extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        const { paymentResponse } = this.props;
        let customerName = paymentResponse?.receipt?.data !== undefined ? paymentResponse.receipt.data[0].consignee : `${this.context.data?.firstname?.toString()} ${this.context.data?.lastname?.toString()}`
        return (
            <Row >
                <Col span={24}>
                    <TableCol {...RightColLayout}>
                        <Row>
                            <strong><HeaderCol span={24} >Receipt Number</HeaderCol></strong>
                        </Row>
                        <Row>
                            <Col span={24}>{paymentResponse?.receipt?.receiptNumber}</Col>
                        </Row>
                    </TableCol>
                    <TableCol {...LeftColLayout}>
                        <Row>
                            <strong><HeaderCol span={24} >Customer</HeaderCol></strong>
                        </Row>
                        <Row>
                            <Col span={24}>{customerName}</Col>
                        </Row>
                    </TableCol>
                    {/* CREATE OWN LAYOUT */}
                    <TableCol {...RightColLayout}>
                        <Row>
                            <strong><HeaderCol span={24} >Date &amp; Time of Payment</HeaderCol></strong>
                        </Row>
                        <Row>
                            <Col span={24}>{Utility.ToDateTimeString(moment(paymentResponse?.receipt?.paymentDate))}</Col>
                        </Row>
                    </TableCol>
                    <TableCol {...LeftColLayout}>
                        <Row>
                            <strong><HeaderCol span={24} >Reference</HeaderCol></strong>
                        </Row>
                        <Row>
                            <Col span={24}>{paymentResponse?.paymentRefenceNumber}</Col>
                        </Row>
                    </TableCol>
                </Col>
            </Row>
        )
    }
}
